<div class="crunch_header">
  <div class="new-logo-container" (click)="goToMainSite()"></div>
</div>

<div class="sign-up-pane">
  <div class="header-font b1Color crunch_header_text" i18n>
    {{ 'START_FORECASTING_IN_BRIXX' | translate }}
  </div>
  <div class="subHeader-font b1Color crunch_subHeader_text" i18n>
    {{ 'CONNECT_YOUR_CRUNCH_ACCOUNT' | translate }}
  </div>

  <div class="crunchSignupWindowText">
    <div class="crunchSignupWindowBox">
      <div class="crunchSignupWindowText">
        <div class="pricing_tick_img"></div>
        <div class="subHeader-font b1Color left-align left-padding" i18n>
          {{ 'CUT_A_BUDGET' | translate }}
        </div>
      </div>

      <div class="crunchSignupWindowText">
        <div class="pricing_tick_img"></div>
        <div class="subHeader-font b1Color left-align left-padding" i18n>
          {{ 'CREATE_A_SALES_FORECAST' | translate }}
        </div>
      </div>

      <div class="crunchSignupWindowText">
        <div class="pricing_tick_img"></div>
        <div class="subHeader-font b1Color left-align left-padding" i18n>
          {{ 'SEE_YOUR_PROJECTED_GROSS' | translate }}
        </div>
      </div>

      <div class="crunchSignupWindowText">
        <div class="pricing_tick_img"></div>
        <div class="subHeader-font b1Color left-align left-padding" i18n>
          {{ 'SEE_YOUR_OPERATING_CASH' | translate }}
        </div>
      </div>

      <div class="crunchSignupWindowText">
        <div class="pricing_tick_img"></div>
        <div class="subHeader-font b1Color left-align left-padding" i18n>
          {{ 'BASED_ON_LAST_12' | translate }}
        </div>
      </div>
    </div>
    <div style="width: 20px"></div>
    <div class="crunch_account_logo"></div>
  </div>

  <div class="crunch_account_line"></div>
  <simple-btn
    class="signup-btn"
    [hoverTextColor]="'white'"
    [backgroundFillCls]="'o2Background'"
    [hoverFillCls]="'o1Background'"
    [boxShadowCls]="'primary-shadow'"
    [text]="createAccountButtonText | translate"
    [textCls]="'very-large-btn-text'"
    [height]="40"
    [cornerRadius]="30"
    [horizontalPadding]="35"
    (click)="crunchSignUp()"
    data-testid="crunchFlowStart"
  >
  </simple-btn>
  <div style="margin-top: 30px">
    <a data-testid="signInLink" class="btn btn-sm crunch-log-in-button" (click)="crunchSignUp()">
      <span style="height: 22px;" class="very-large-btn-text" i18n>{{ 'LOG_IN' | translate }}</span>
    </a>
  </div>
  <div class="terms-block">
    <div class="font14bold b1Color" i18n>
      {{ 'BY_CREATING_AN_ACCOUNT' | translate }}
      <a
        class="termsLabel"
        href="https://www.brixx.com/terms-conditions/"
        target="_blank"
        >{{ 'TERMS' | translate }} &amp; {{ 'CONDITIONS' | translate }}</a
      >
      <span>&nbsp;&&nbsp;</span
      ><a
        class="termsLabel"
        href="https://www.brixx.com/privacy-policy/"
        target="_blank"
        >{{ 'PRIVACY_POLICY' | translate }}</a
      >
    </div>

    <div [height]="5"></div>

    <div id="newsCheckBoxContainer" class="checkboxContainer">
      <input
        type="checkbox"
        (change)="toggleGetNews()"
        id="newsCheckBox"
        name="newsCheckBox"
        class="checkboxLeft newsCheckBox"
      />
      <label
        for="newsCheckBox"
        data-testid="sendNewsCheckBox"
        style="width: 100%"
      >
        <span class="b1Color" id="firstNewsRow"
           i18n>{{ 'BE_THE_FIRST_TO' | translate }}&nbsp;</span
        >
        <span class="b1Color" id="secondNewsRow"
           i18n>{{ 'EVOLVING_PLATFORM_AND_OUR' | translate }}</span
        >
      </label>
    </div>
  </div>
</div>
